var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourlyHiring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1214_5922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4548 50.4232V51.1732H51.2048H72.6973C73.4042 51.1732 73.9818 51.755 73.9818 52.4577V58.5693C73.9818 59.2762 73.3999 59.8538 72.6973 59.8538H41.766V26.8717C41.766 26.1668 42.3459 25.5872 43.0586 25.5872H49.1702C49.8709 25.5872 50.4548 26.171 50.4548 26.8717V50.4232ZM49.9922 0.75C77.1903 0.75 99.2422 22.8019 99.2422 50C99.2422 77.1981 77.1903 99.25 49.9922 99.25C22.7941 99.25 0.742188 77.1981 0.742188 50C0.742188 22.8019 22.7941 0.75 49.9922 0.75ZM89.3897 50C89.3897 28.2398 71.7524 10.6025 49.9922 10.6025C28.2318 10.6025 10.5947 28.248 10.5947 50C10.5947 71.7602 28.2319 89.3975 49.9922 89.3975C71.7524 89.3975 89.3897 71.7602 89.3897 50Z",
    stroke: "#134046",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1214_5922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(-0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourlyHiring);
export default __webpack_public_path__ + "static/media/hourly_hiring.c6f420e54b6f14d4be512d00df530558.svg";
export { ForwardRef as ReactComponent };